import { useEffect } from 'react';
import { bindEnCasingLang } from '../utils/latinCase';

export default function EnCasingBoot() {
  useEffect(() => bindEnCasingLang(document.body), []);
  return null;
}
